// @ vendor
const React = require('react');
const { PropTypes } = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ components
const { OKButton } = require('commonsComponents/OKButton');

// @ actions
const okConsentsActions = require('../../actions/OKConsents');

// @ constants
const { OKCONSENTS_EMPTY_VALUE } = require('../../constants/constants');

class OKConsentsUpdateButton extends React.Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        this.props.onClick();
    }

    render() {
        const {
            isFetching,
            modifier,
            postIsFetching,
            textTranslationKey
        } = this.props;
        return (
            <OKButton
                disabled={isFetching}
                loading={isFetching || postIsFetching}
                modifier={modifier}
                onClick={this.handleClick}
            >
                <FormattedText value={textTranslationKey} />
            </OKButton>
        );
    }
}

OKConsentsUpdateButton.defaultProps = {
    modifier: 'primary'
}

OKConsentsUpdateButton.propTypes = {
    immConsents: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    modifier: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    postIsFetching: PropTypes.bool.isRequired,
    textTranslationKey: PropTypes.string.isRequired
};

module.exports.constructor = OKConsentsUpdateButton;
module.exports.OKConsentsUpdateButton = connect(
    state => ({
        immConsents: state.gdprConsents.get('consents'),
        isFetching: state.gdprConsents.get('isFetching'),
        postIsFetching: state.gdprConsents.get('postIsFetching'),
    }),
    null
)(OKConsentsUpdateButton);
